function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import PictureComponent from "/components/core/picture/picture-component";
import SelectableTagsGrid from "segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import DefaultProps from "./default-props";
import { trackEvent } from "/services/bigbrain-service";
import { CAROUSEL_SWIPED, CAROUSEL_SLIDE_CHANGED } from "/constants/bigbrain-event-types";
import { StyledSelectableTagsWithCarouselGridComponent } from "./selectable-tags-with-carousel-grid-component.scss";
const SelectableTagsWithCarouselGridComponent = (props)=>{
    const { tagsAlign, gridSelectableTags } = props;
    const [selectedIndex, setSelectedIndex] = useState(null);
    const onTagToggle = (values)=>{
        var _values_;
        const newIndex = values.length >= 1 ? (_values_ = values[values.length - 1]) === null || _values_ === void 0 ? void 0 : _values_.index : null;
        setSelectedIndex(newIndex);
    };
    const itemRenderer = (image)=>{
        return /*#__PURE__*/ _jsx(PictureComponent, {
            className: "cluster-tag-image",
            src: image === null || image === void 0 ? void 0 : image.src,
            alt: image === null || image === void 0 ? void 0 : image.alt
        });
    };
    const onSwipe = (direction)=>{
        trackEvent(CAROUSEL_SWIPED, {
            kind: direction
        });
    };
    const onCarouselSlideChange = (current)=>{
        trackEvent(CAROUSEL_SLIDE_CHANGED, {
            kind: current
        });
    };
    const tagsImages = (gridSelectableTags || []).map((item)=>item === null || item === void 0 ? void 0 : item.galleryImage);
    return /*#__PURE__*/ _jsxs(StyledSelectableTagsWithCarouselGridComponent, {
        className: "selectable-tags-with-carousel-grid-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "selectable-tags-grid-wrapper",
                children: /*#__PURE__*/ _jsx(SelectableTagsGrid, _object_spread_props(_object_spread({}, props), {
                    align: tagsAlign,
                    onTagToggle: onTagToggle
                }))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ _jsx(Carousel, _object_spread_props(_object_spread({}, props), {
                    items: tagsImages,
                    selectedIndex: selectedIndex,
                    itemRenderer: itemRenderer,
                    onSwipe: onSwipe,
                    onChange: onCarouselSlideChange
                }))
            })
        ]
    });
};
SelectableTagsWithCarouselGridComponent.defaultProps = DefaultProps;
export default SelectableTagsWithCarouselGridComponent;
